import React from 'react';
import classNames from 'classnames';
import { ProjectsAPI } from 'ducks/types/api-types';
import { JobDates } from 'ducks/types/common-types';
import { MegaMenuProps } from 'ducks/types/prop-types';
import { useQuerySave } from 'hooks/useQuerySave';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { Link, useLocation, useParams } from 'react-router-dom';

import cn from 'components/mega-menu/megaMenu.module.scss';

export const MegaMenu = ({ labels, values, page }: MegaMenuProps) => {
  const { theme, is_dark_theme } = useSwitchTheme();
  const { job_state } = useParams() || {};
  const { search, pathname } = useLocation();

  const { mergeQueries, getJobsQuery, getPageQueries } = useQuerySave({
    page: 'jobs',
    search: search,
  });

  const linkMegaMenu = (item: ProjectsAPI | JobDates) => {
    switch (page) {
      case 'jobs':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/jobs/${job_state}${getJobsQuery()}`}
          >
            {item.project_name}
          </Link>
        );
      case 'jobs_range':
        if (!('range_name' in item)) return;
        return (
          <Link
            key={item.range_name}
            className={cn.option}
            to={`${pathname}/${mergeQueries({
              range_name: item.range_name,
              start_date: item.start_date,
              finish_date: item.finish_date,
            })}`}
          >
            {item.range_name}
          </Link>
        );
      case 'batches':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/batches/all${getPageQueries('batches')}`}
          >
            {item.project_name}
          </Link>
        );
      case 'job':
        if (!('project_id' in item)) return;
        return (
          <Link key={item.project_id} className={cn.option} to={`/projects/${item.project_id}/jobs/all${search}`}>
            {item.project_name}
          </Link>
        );
      case 'job_definition':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/job_definitions/all${search}`}
          >
            {item.project_name}
          </Link>
        );
      case 'job_definitions':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/job_definitions/all${getPageQueries('job_definitions')}`}
          >
            {item.project_name}
          </Link>
        );
      case 'batch_definitions':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/batch_definitions/all/${getPageQueries('batch_definition')}`}
          >
            {item.project_name}
          </Link>
        );
      case 'scheduled_batch':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/scheduled_batches/all/${search}`}
          >
            {item.project_name}
          </Link>
        );
      case 'scheduled_batches':
        if (!('project_id' in item)) return;
        return (
          <Link
            key={item.project_id}
            className={cn.option}
            to={`/projects/${item.project_id}/scheduled_batches/all${getPageQueries('scheduled_batches')}`}
          >
            {item.project_name}
          </Link>
        );
      default:
        return <p>nothing to select</p>;
    }
  };

  return (
    <>
      <div
        className={classNames(cn.wrapper, {
          [cn.dark]: is_dark_theme,
        })}
      >
        <div className={cn.dropdown}>
          <p className={cn.base}>{labels || 'Projects'}</p>
          <div
            className={cn.options}
            style={{
              background: theme.inputs.input_background,
              border: theme.inputs.input_border,
            }}
          >
            {values.map((value) => linkMegaMenu(value))}
          </div>
        </div>
      </div>
    </>
  );
};
